import { AnimatedLogo } from "../../components/AnimatedLogo/AnimatedLogo"

export const SpinnerView = () => {
	return (
		<div className="bg-(--color-background) fixed inset-0 z-[10000] flex items-center justify-center">
			<AnimatedLogo />
		</div>
	)
}
